<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label:`${label} (${displayValue})`,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <div class="form-slider__container">
      <VueSlider
        :value="mergedValue"
        v-bind="settings"
        :disabled="disabled"
        @change="update"
      >
      </VueSlider>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import FormMixin from './FormMixin'
import FormLabel from './FormLabel'

const DEFAULT_ONE_SIDED_SETTINGS = {
  marks: true,
  contained: true,
  lazy: true,
}
const DEFAULT_BOTH_SIDED_SETTINGS = {
  enableCross: false,
  marks: true,
  contained: true,
  lazy: true,
}

export default {
  mixins: [ FormMixin ],
  components: { VueSlider, FormLabel },
  props: {
    value: {
      type: [
        Array,
        Number,
        String,
      ],
      default: 0,
    },
  },
  computed: {
    mergedValue () {
      return this.value && (!Array.isArray(this.value) || this.value.length)
        ? this.value
        : this.config.init
    },
    isBothSided () {
      return Array.isArray(this.mergedValue)
    },
    defaultSettings () {
      return this.isBothSided
        ? DEFAULT_BOTH_SIDED_SETTINGS
        : DEFAULT_ONE_SIDED_SETTINGS
    },
    settings () {
      return { ...this.defaultSettings, ...this.config }
    },
    displayValue () {
      return this.isBothSided
        ? this.mergedValue.join(' - ')
        : this.mergedValue
    },
  },
  methods: {
    update (value) {
      if (this.isBothSided &&
      this.settings.min !== undefined &&
      this.settings.max !== undefined &&
      this.settings.min === Number(value[0]) &&
      this.settings.max === Number(value[1])) {
        return this.$emit('input', [])
      }
      return this.$emit('input', value)
    },
  },
}
</script>

<style scoped>
@import "~vue-slider-component/theme/material.css";
.form-slider__container {
  height: 38px;
  padding-top: 4px;
}
.form-slider__container >>> .vue-slider-dot-handle,
.form-slider__container >>> .vue-slider-process,
.form-slider__container >>> .vue-slider-dot-tooltip-inner {
  background-color: var(--blue);
}
.form-slider__container >>> .vue-slider-rail {
  background-color: var(--gray);
}
.form-slider__container >>> .vue-slider-dot-handle::after {
  background-color: var(--blue);
  opacity: 0.3;
}
.form-slider__container >>> .vue-slider-mark-step {
  background-color: rgba(100, 100, 100, 0.2);
}
.form-slider__container >>> .vue-slider-mark-step-active {
  background-color: rgba(255, 255, 255, 0.4);
}
.form-slider__container >>> .vue-slider-mark-label {
  font-size: 12px;
  margin-top: 5px;
  color: var(--text-muted);
}
.form-slider__container >>> .vue-slider-dot-tooltip-top {
  top: -5px;
}
.form-slider__container
  >>> .vue-slider-dot-tooltip-inner
  .vue-slider-dot-tooltip-text {
  width: 22px;
  height: 22px;
  font-size: 11px;
  -webkit-font-smoothing: antialiased;
  -webkit-backface-visibility: hidden;
}
</style>
